import { TELNYX_RECIPIENT_OPTED_OUT_ERROR_CODE } from '@minty/shared/sms';
import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  MessageBubble,
  MessageBubbleFooter,
  MessageRow,
} from './message-bubble';
import type { SmsActivity } from './types';
import { getSmsStatusLabel } from '~/components/sms-status-label';
import { formatDateTime } from '~/lib/dates';
import { cn } from '~/lib/utils';

export function SmsActivityMessage({ activity }: { activity: SmsActivity }) {
  const { t } = useTranslation('tasks');
  const isOutbound = activity.direction === 'outbound';
  const statusLabel = getSmsStatusLabel(activity.status, t);
  const errorMessage =
    activity.errorCode === TELNYX_RECIPIENT_OPTED_OUT_ERROR_CODE
      ? t('Recipient opted out')
      : (activity.errorDetail ?? activity.errorTitle);

  return (
    <MessageRow isOutbound={isOutbound} handledBy={activity.handledBy}>
      <MessageBubble isOutbound={isOutbound} className="max-w-[520px]">
        <p className="min-h-6 whitespace-pre-wrap wrap-anywhere text-sm leading-5">
          {activity.body}
        </p>
        {activity.hasUnsupportedMedia && (
          <p className="text-xs font-medium opacity-80">
            {t('Attachment not supported')}
          </p>
        )}
        {errorMessage && (
          <p
            className={cn(
              'text-xs',
              isOutbound ? 'opacity-80' : 'text-destructive',
            )}
          >
            {errorMessage}
          </p>
        )}
        <MessageBubbleFooter
          icon={MessageSquare}
          label={
            statusLabel === null
              ? formatDateTime(activity.createdAt)
              : `${statusLabel} · ${formatDateTime(activity.createdAt)}`
          }
        />
      </MessageBubble>
    </MessageRow>
  );
}
